import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { useForm, ValidationError } from '@formspree/react';
import { MaskText, SectionLabel } from './ui/Reveal';
import { FORMSPREE_NEWSLETTER_ID } from '../data/site';
export function Newsletter() {
  const [state, handleSubmit] = useForm(FORMSPREE_NEWSLETTER_ID);
  const [email, setEmail] = useState('');
  return <section className="bg-surface py-20 sm:py-24" aria-label="Newsletter" data-id="element-366" data-mp="3uggmk97msd58">
      <div className="mx-auto w-full max-w-container px-5 sm:px-8" data-id="element-367" data-mp="3948i321oftj">
        <div className="grid gap-10 border-t border-line pt-10 lg:grid-cols-[1.1fr_0.9fr] lg:items-center" data-id="element-368" data-mp="3leh7hmg6fj4x">
          <div data-id="element-369" data-mp="3qdbpim6bl3nz">
            <SectionLabel data-id="element-370" data-mp="3qcsgjuyndpm3">Newsletter</SectionLabel>
            <h2 className="mt-5 max-w-xl font-display text-3xl font-extrabold uppercase leading-[0.92] tracking-tightest sm:text-5xl" data-id="element-371" data-mp="3qfoevkeeqgb2">
              <MaskText text="Ideas, Inspiration|& Creative Thinking." data-id="element-372" data-mp="2eyy5xtilnadr" />
            </h2>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-muted sm:text-base" data-id="element-373" data-mp="2s23dwdvarcw6">
              Join our newsletter for creative insights, design inspiration, branding ideas and
              occasional updates from Morvix.
            </p>
          </div>

          <div data-id="element-374" data-mp="321u8efjuxrw9">
            <AnimatePresence mode="wait" data-id="element-375" data-mp="31y6irrhj9pmt">
              {state.succeeded ? <motion.div key="success" initial={{
              opacity: 0,
              y: 12
            }} animate={{
              opacity: 1,
              y: 0
            }} className="flex items-start gap-4 border border-brand bg-brand/5 p-6" role="status" data-id="element-376" data-mp="2x050v9vufwcx">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand" data-id="element-377" data-mp="3kq8z11q9j3wj">
                    <CheckIcon className="h-3.5 w-3.5 text-white" aria-hidden="true" data-id="element-378" data-mp="3fua7j59n15rw" />
                  </span>
                  <div data-id="element-379" data-mp="3pq3ulikzghnx">
                    <p className="font-display text-lg font-bold uppercase tracking-tight" data-id="element-380" data-mp="3pqwqfoielmra">
                      You’re in.
                    </p>
                    <p className="mt-1 text-sm text-muted" data-id="element-381" data-mp="ltanozep1jt">
                      Creative thinking, straight to your inbox — no noise.
                    </p>
                  </div>
                </motion.div> : <motion.form key="form" onSubmit={handleSubmit} className="attention-pulse flex flex-col gap-3 p-2 sm:flex-row" initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} data-id="element-382" data-mp="fck38z8to4nz">
                  <input type="hidden" name="_subject" value="New newsletter subscriber — morvixgraphics.com" data-id="element-383" data-mp="tcldv6ew2qgn" />
                  <input type="hidden" name="form_type" value="Newsletter signup" data-id="element-384" data-mp="y9brln3819yw" />

                  <div className="flex-1" data-id="element-385" data-mp="2v615a5isw9co">
                    <label htmlFor="newsletter-email" className="sr-only" data-id="element-386" data-mp="302j7oyqnrvlu">
                      Email address
                    </label>
                    <input id="newsletter-email" type="email" name="email" required autoComplete="email" value={email} onChange={event => setEmail(event.target.value)} placeholder="your@email.com" className="w-full border border-line bg-transparent px-4 py-4 text-sm text-ink placeholder:text-muted/70 focus:border-brand focus:outline-none" data-id="element-387" data-mp="1h9hm86nn8n74" />
                    <ValidationError prefix="Email" field="email" errors={state.errors} className="mt-2 block text-xs text-brand" data-id="element-388" data-mp="1r5kxq34dxy6q" />
                  </div>
                  <button type="submit" disabled={state.submitting} className="bg-brand px-7 py-4 text-[0.78rem] font-medium uppercase tracking-[0.16em] text-white transition-colors hover:bg-brand-deep disabled:opacity-60" data-id="element-389" data-mp="fokz6prg2n49">
                    {state.submitting ? 'Subscribing…' : 'Subscribe'}
                  </button>
                </motion.form>}
            </AnimatePresence>
            {!state.succeeded && state.errors ? <p className="mt-3 text-xs text-muted" data-id="element-390" data-mp="2ict3iu9zvlbc">
                Something went wrong. Please try again in a moment.
              </p> : null}
          </div>
        </div>
      </div>
    </section>;
}